import { NumberCircle } from '@/components/generic/NumberCircle';
import { generatePath, NavLink } from 'react-router';
import clsx from 'clsx';
import { AppRoutes } from '../../../AppRoutes';
import { User } from '@/slices/account/account.types';

export const AdminUserListItem = ({
  user,
  index,
}: {
  user: User;
  index: number;
}) => {
  return (
    <li className="flex items-center gap-2">
      <NumberCircle number={index + 1} size={6} />
      <span>
        <NavLink
          to={
            (!user.disabled &&
              generatePath(AppRoutes.AdminUser, {
                id: user.id,
              })) ||
            ''
          }
          className={clsx('flex items-center gap-2')}
        >
          <div className={clsx(user.disabled && 'text-gray-400')}>
            {user.firstName} {user.lastName}
          </div>
          <div className="flex items-center gap-2">
            {user.roles.map((role) => (
              <div key={`${user.id} ${role}`} className="tag purple">
                {role}
              </div>
            ))}
          </div>
        </NavLink>
      </span>
    </li>
  );
};
